import React, { useState, useEffect } from "react";
import useEnv from "../hooks/useEnv";
import { useNavigate } from "react-router-dom";

const PcoGroupItem = ({ group, onToggle, isChecked = false }) => {
  const [checked, setChecked] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const envUrl = useEnv();
  const navigate = useNavigate();

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleClose = () => {
    setSelectedImage(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
    onToggle(e.target.checked, group);
  };

  const handleGroupClick = () => {
    navigate(`/groups/${group.title}`, { state: { groupData: group } });
  };

  const handleResendInvite = async (group) => {
    try {
      await fetch(`${envUrl}/groupEmailManager`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ group_id: group.pco_id, org_id: group.organizationId, flag: 'leaders' })
      });
      alert('Invite resent successfully');
    } catch (error) {
      console.error('Error resending invite:', error);
      alert('Error resending invite');
    }
  };

  return (
    <>
      <li className="mb-4 flex items-center p-4 dashboard-on-element rounded-lg shadow-md" onClick={handleGroupClick}>
        <img
          src={group.grpAvatar}
          alt={group.name}
          className="w-24  rounded-lg mr-4 cursor-pointer"
          onClick={() => handleImageClick(group.grpAvatar)}
        />
        <span className="text-lg font-medium flex-grow">{group.title}</span>
        {!group.joltActivated && (
          <label className="switch groups-toggle">
            <input 
              type="checkbox" 
              className="groupchk" 
              checked={checked}
              onChange={handleCheckboxChange} 
            />
            <span className="slider round"></span>
          </label>
        )}
                {group.joltActivated && (
                    <button 
            className="text-xs text-white border border-white rounded-lg px-2 py-1 hover:bg-[#ff6256] hover:text-white transition-colors duration-200"
            onClick={() => handleResendInvite(group)}
          >
            Resend Invite
          </button>
           
        )}
      </li>

      {selectedImage && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
          onClick={handleOverlayClick}
        >
          <div className="relative">
            <img src={selectedImage} alt="Selected" className="max-w-full max-h-full rounded-lg" />
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={handleClose}
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PcoGroupItem;